import { Status } from './../components/Market/types';

export const statuses: Status[] = [
  { title: 'Total Deposited', value: '730.53', unit: 'Million USD' },
  { title: '24H Volume', value: '10.28', unit: 'Million USD' },
  { title: '24H Fees', value: '0.89', unit: 'Million USD' },
  { title: '24H Trades', value: '3,256', unit: 'Times' },
];